<template>
  <v-card elevation="0" outlined>
    <v-expansion-panels :value="needsToBringPanelOpened(questions.length)" class="expansion-panels__no-elevation" accordion multiple>
      <v-expansion-panel v-for="question in questions" :key="question.id">
        <v-expansion-panel-header>
          <span class="font-weight-bold body-1">
            {{ question.label }}
            <span v-if="question.required" class="required primary--text font-weight-bold">*</span>
          </span>
          <div v-if="canEditQuestion" class="d-flex justify-end mr-3">
            <v-menu left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon small>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="editQuestion(question.id)">
                  <v-icon class="mr-3 grey--text text--lighten-1" style="transform: scale(0.85); opacity: 0.75"> mdi-pencil-outline </v-icon>
                  <span class="d-block body-2">
                    {{ $t('question.actions.editQuestion') }}
                  </span>
                </v-list-item>
                <v-list-item @click="openConfirmDeleteModal(question)">
                  <v-icon class="mr-3 error--text text--lighten-1" style="transform: scale(0.85); opacity: 0.75"> mdi-delete-outline </v-icon>
                  <span class="error--text d-block body-2">
                    {{ $t('question.actions.removeQuestion') }}
                  </span>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="grey lighten-5 py-2 px-6">
            <v-row>
              <v-col>
                <h6 class="text-uppercase grey--text">
                  {{$t('question.label.type')}}
                </h6>
                <span class="body-1">
                  {{ $t(`question.type.${question.type}`) }}
                </span>
              </v-col>
            </v-row>

            <v-row v-if="hasAnswerOptions(question)">
              <v-col>
                <h6 class="text-uppercase grey--text">
                  {{$t('question.label.answerOptions')}}
                </h6>
                <span class="d-block body-1" v-for="answer in question.answer_options" :key="answer.id">
                  {{ `- ${answer.label}` }}
                </span>
              </v-col>
            </v-row>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import { checkUserRole } from '@/util/helpers'

export default {
  name: 'Questions',

  props: {
    questions: {
      type: Array,
      required: false,
    },
  },

  computed: {
    canEditQuestion() {
      return !checkUserRole(['ROLE_SUPPORT'])
    },
  },

  methods: {
    needsToBringPanelOpened(length) {
      return length > 1 ? [] : [0]
    },

    hasAnswerOptions(question) {
      return question.answer_options && question.answer_options.length > 0
    },

    openConfirmDeleteModal(question) {
      this.$parent.$refs?.confirmDeleteModal.openConfirmModal(question)
    },

    editQuestion(id) {
      this.$parent.$refs?.createUpdateQuestionModal.openUpdateQuestionModal(id, this.id)
    },
  }
}
</script>
